import { render, staticRenderFns } from "./StockComponent.vue?vue&type=template&id=9a954260&scoped=true"
import script from "./StockComponent.vue?vue&type=script&lang=js"
export * from "./StockComponent.vue?vue&type=script&lang=js"
import style0 from "./StockComponent.vue?vue&type=style&index=0&id=9a954260&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a954260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a954260')) {
      api.createRecord('9a954260', component.options)
    } else {
      api.reload('9a954260', component.options)
    }
    module.hot.accept("./StockComponent.vue?vue&type=template&id=9a954260&scoped=true", function () {
      api.rerender('9a954260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockComponent.vue"
export default component.exports